import $ from "jquery";

(function(){
    var	registration = {
        init: function() {
            $("#loginForm").submit(function (e) {
                e.preventDefault();
        
                $.ajax({
                    type: $(this).attr("method"),
                    url: $(this).attr("action"),
                    dataType: "json",
                    data: $(this).serialize(),
                    success: function (data) {
                        window.location.replace(data.redirectUrl);
                    },
                    statusCode: {
                        422: function () {
                            $("#loginErrorMessage").html("<div class='alert alert-danger' role='alert'>Неверный логин или пароль</div>")
                        }
                    }
                });
            });
        
            // Physical or Company fields
            $("#typePhysical").on("change", function () {
                if ($(this).prop("checked", true)) {
                    $("#legalInputsWrapper").slideUp(200);
                }
            });
        
            $("#typeCompany").on("change", function () {
                if ($(this).prop("checked", true)) {
                    $("#legalInputsWrapper").slideDown(200);
                }
            });
        
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/register.js